
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neet-ug",
      function () {
        return require("private-next-pages/neet-ug.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neet-ug"])
      });
    }
  